import React from 'react'
import { AccountHeader } from '@mobi/component-library/Areas/Account'

/**
 * Display a header for the Deposit screen, with an optional close
 * button
 */
export const DepositHeader = ({
  title,
  onClose,
  description,
}: {
  title: string
  description?: string
  onClose?: VoidFunction
}) => {
  return (
    <AccountHeader alignItems='start' title={title} description={description} onClose={onClose} />
  )
}
